/* IlloImg — canonical ORIO illustration renderer.
   Loads the primary /static/illustrations/<slug>.png and only shows the
   Unsplash fallback when the primary actually fails (onError). This prevents
   the "levriero flash" bug where the CSS background-image multi-url stack
   would render the fallback under the primary during load, showing a wrong
   photo for a fraction of a second.

   Use exactly like <img>: `<IlloImg slug="feat-walk" className="..." />`
*/
import React, { useState } from "react";
import { orioIllustration, orioIllustrationFallback } from "@/lib/illustrations";

export default function IlloImg({
  slug,
  className = "",
  alt = "",
  loading = "lazy",
  style,
  onLoad,
}) {
  const [errored, setErrored] = useState(false);
  const src = errored ? orioIllustrationFallback(slug) : orioIllustration(slug);
  return (
    <img
      src={src}
      alt={alt}
      loading={loading}
      decoding="async"
      onError={() => setErrored(true)}
      onLoad={onLoad}
      className={className}
      style={{ background: "#FFF5E9", ...style }}
    />
  );
}
